import * as React from "react";
import * as ReactDOM from "react-dom";
import StoreContainer from "../stores/StoreContainer";
import { InlineImageInvite } from "../types";

interface InlineImageInvitePortalProps {
  container: HTMLElement;
  invite: InlineImageInvite;
}

class InlineImageInvitePortal extends React.Component<
  InlineImageInvitePortalProps,
  {}
> {
  container: HTMLDivElement;

  state = {
    loaded: false
  };

  componentDidMount() {
    this.container = document.createElement("div");
    this.container.className = "velaro-inline-invite-frame";
    this.props.container.appendChild(this.container);

    this.setState({ loaded: true });

    if (this.props.invite.secondsToDisplay) {
      setTimeout(
        () => StoreContainer.InviteStore.closeInlineInvite(),
        this.props.invite.secondsToDisplay * 1000
      );
    }
  }

  componentWillUnmount() {
    this.props.container.removeChild(this.container);
  }

  onClickReject = () => {
    StoreContainer.InviteStore.reject();
    StoreContainer.InviteStore.closeInlineInvite();
  };

  onClickAccept = () => {
    StoreContainer.InviteStore.accept();
    StoreContainer.InviteStore.closeInlineInvite();
    StoreContainer.FrameStore.expandOrPopout();
  };

  renderInvite() {
    return (
      <div className="velaro-inline-invite">
        <div onClick={this.onClickAccept} role="button" aria-hidden="true">
          <img src={this.props.invite.imageUrl} alt="" role="presentation" />
        </div>
        <button
          className="velaro-inline-invite-reject-btn"
          onClick={this.onClickReject}
        >
          x
        </button>
      </div>
    );
  }

  render() {
    if (!this.state.loaded) {
      return null;
    }

    return ReactDOM.createPortal(this.renderInvite(), this.container);
  }
}

export default InlineImageInvitePortal;
